import { Box, Drawer } from '@mui/material'
import React, { useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu'
import SideBar from '.'

const MobileSideBar = () => {
  const [show, setShow] = useState(false)

  const toggleDrawer = (event) => {
    if (
      event.type === 'keydown'
      && (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return null
    }

    setShow((ps) => !ps)
  }

  return (
    <>
      <MenuIcon
        onClick={toggleDrawer}
        style={{ color: '#333' }}
        className='scale-125 mx-[2.5vw]'
      />
      <Drawer anchor='left' open={show} onClose={toggleDrawer}>
        <Box sx={{ width: 'max(250px, 40vw)' }} onClick={toggleDrawer}>
          <SideBar mobile />
        </Box>
      </Drawer>
    </>
  )
}
export default MobileSideBar
